<div class="wheel-legend-container">
  <app-profit-zone-guide-link></app-profit-zone-guide-link>

  <app-wheel-chart-legend
    *appHideForUnavailableFeature="features.LowHighIndicator; else lowHighIndicatorPlaceholder"
  ></app-wheel-chart-legend>

  <ng-template #lowHighIndicatorPlaceholder>
    <div class="low-high-indicator-placeholder">
      <button
        (click)="$event.preventDefault(); redirectToLowHighIndicatorDemoPage()"
        mat-button
        class="mat-button-link link-button locked-for-current-edition"
      >
        Lowest / Highest Close
      </button>
    </div>
  </ng-template>
</div>

<app-doubled-chart
  [defaultChartType]="chartTypes.Day1"
  [afterSavedDataRestored]="afterSavedDataRestored.bind(this)"
  [chartSavedDataKey]="chartSavedDataKey"
  [chartSavedDataKeyPrefix]="'wheel'"
  [isDeveloperAccount]="isDeveloperAccount"
  [getChartShapeIdsToExclude]="getChartShapeIdsToExclude"
  [getCustomIndicators]="getCustomIndicators"
  [getTimescaleMarks]="getTimescaleMarks"
  [getExpectedMoveOptions]="getExpectedMoveOptions"
  [loadChartData]="loadChartData"
  [symbol$]="currentSymbol$"
  [resetChart$]="resetChart$"
  [disabledIndicators]="disabledIndicators"
  [widgetOptionsOverridesFor1DayChart]="widgetOptionsOverridesFor1DayChart"
  [widgetOptionsOverridesFor15MinChart]="widgetOptionsOverridesFor15MinChart"
  [widgetOptionsOverridesFor5MinChart]="widgetOptionsOverridesFor5MinChart"
  [widgetOptionsOverridesFor1MinChart]="widgetOptionsOverridesFor1MinChart"
  [indicatorsOverrideFor1DayChart]="indicatorsOverrideFor1DayChart"
  (chartReady)="onChartReady($event)"
  (symbolChanged)="onSymbolChanged($event)"
  class="chart-wheel-strategy-container"
></app-doubled-chart>

@if (false) {
  <div class="chart-overlay"></div>
}
